export default  {
	id: '',
	builder: '',
	lot_type: '',
	section_id: '',
	start: '',
	end: '',
	base_price: '',
	notes: '',
	property: '',
	data: {}
}